export const CATEGORY_META = {
  jobs: { en: "Latest Government Jobs", hi: "नवीनतम सरकारी नौकरी", short_en: "Jobs", short_hi: "नौकरी" },
  results: { en: "Results", hi: "परिणाम", short_en: "Results", short_hi: "परिणाम" },
  "admit-card": { en: "Admit Cards", hi: "प्रवेश पत्र", short_en: "Admit Card", short_hi: "प्रवेश पत्र" },
  "answer-key": { en: "Answer Keys", hi: "उत्तर कुंजी", short_en: "Answer Key", short_hi: "उत्तर कुंजी" },
  syllabus: { en: "Syllabus", hi: "पाठ्यक्रम", short_en: "Syllabus", short_hi: "पाठ्यक्रम" },
  admissions: { en: "Admissions", hi: "प्रवेश", short_en: "Admissions", short_hi: "प्रवेश" },
  scholarships: { en: "Scholarships", hi: "छात्रवृत्ति", short_en: "Scholarships", short_hi: "छात्रवृत्ति" },
  schemes: { en: "Government Schemes", hi: "सरकारी योजनाएँ", short_en: "Schemes", short_hi: "योजनाएँ" },
};

export const CATEGORY_ORDER = [
  "jobs", "results", "admit-card", "answer-key", "admissions", "scholarships", "syllabus", "schemes",
];

export const FILTER_TAGS = [
  { slug: "10th-pass", en: "10th Pass", hi: "10वीं पास" },
  { slug: "12th-pass", en: "12th Pass", hi: "12वीं पास" },
  { slug: "graduate", en: "Graduate", hi: "स्नातक" },
  { slug: "post-graduate", en: "Post Graduate", hi: "स्नातकोत्तर" },
  { slug: "diploma", en: "Diploma", hi: "डिप्लोमा" },
  { slug: "iti", en: "ITI", hi: "आईटीआई" },
  { slug: "engineering", en: "Engineering", hi: "इंजीनियरिंग" },
  { slug: "teaching", en: "Teaching", hi: "शिक्षण" },
  { slug: "banking", en: "Banking", hi: "बैंकिंग" },
  { slug: "railway", en: "Railway", hi: "रेलवे" },
  { slug: "ssc", en: "SSC", hi: "एसएससी" },
  { slug: "upsc", en: "UPSC", hi: "यूपीएससी" },
  { slug: "police", en: "Police", hi: "पुलिस" },
  { slug: "defence", en: "Defence", hi: "रक्षा" },
  { slug: "state-government", en: "State Govt.", hi: "राज्य सरकार" },
  { slug: "central-government", en: "Central Govt.", hi: "केंद्र सरकार" },
];

export const T = {
  brand: { en: "Naukri Suchna", hi: "नौकरी सूचना" },
  tagline: {
    en: "Verified Indian government notifications, results & exam updates — in one place.",
    hi: "प्रामाणिक सरकारी अधिसूचनाएँ, परिणाम और परीक्षा अपडेट — एक ही स्थान पर।",
  },
  nav: {
    home: { en: "Home", hi: "मुख्य पृष्ठ" },
    search: { en: "Search", hi: "खोज" },
    about: { en: "About", hi: "हमारे बारे में" },
    contact: { en: "Contact", hi: "संपर्क" },
    admin: { en: "Admin", hi: "व्यवस्थापक" },
  },
  ui: {
    view_details: { en: "View Details", hi: "विवरण देखें" },
    view_all: { en: "View All", hi: "सभी देखें" },
    last_date: { en: "Last Date", hi: "अंतिम तिथि" },
    posted_on: { en: "Posted", hi: "पोस्ट किया गया" },
    organization: { en: "Organization", hi: "संगठन" },
    status: { en: "Status", hi: "स्थिति" },
    apply_online: { en: "Apply Online", hi: "ऑनलाइन आवेदन करें" },
    download_pdf: { en: "Download Notification (PDF)", hi: "अधिसूचना डाउनलोड करें (PDF)" },
    official_website: { en: "Official Website", hi: "आधिकारिक वेबसाइट" },
    important_dates: { en: "Important Dates", hi: "महत्वपूर्ण तिथियाँ" },
    application_fee: { en: "Application Fee", hi: "आवेदन शुल्क" },
    age_limit: { en: "Age Limit", hi: "आयु सीमा" },
    qualification: { en: "Qualification", hi: "योग्यता" },
    vacancy_details: { en: "Vacancy Details", hi: "रिक्तियों का विवरण" },
    category_wise: { en: "Category-wise Vacancy", hi: "श्रेणी-वार रिक्तियाँ" },
    selection: { en: "Selection Process", hi: "चयन प्रक्रिया" },
    salary: { en: "Salary / Pay Scale", hi: "वेतन" },
    how_to_apply: { en: "How to Apply", hi: "आवेदन कैसे करें" },
    important_links: { en: "Important Links", hi: "महत्वपूर्ण लिंक" },
    faqs: { en: "Frequently Asked Questions", hi: "अक्सर पूछे जाने वाले प्रश्न" },
    total_vacancies: { en: "Total Vacancies", hi: "कुल रिक्तियाँ" },
    advertisement_no: { en: "Advertisement No.", hi: "विज्ञापन क्रमांक" },
    demo_disclaimer: {
      en: "This is a clearly-labelled sample post for demonstration only. Always verify from the official government notification.",
      hi: "यह केवल प्रदर्शन के लिए एक स्पष्ट रूप से चिह्नित नमूना पोस्ट है। कृपया आधिकारिक सरकारी अधिसूचना से पुष्टि करें।",
    },
    search_placeholder: { en: "Search by post, organization, qualification…", hi: "पोस्ट, संगठन, योग्यता से खोजें…" },
    no_results: { en: "No matching notifications yet.", hi: "अभी कोई मिलती-जुलती अधिसूचना नहीं।" },
    filter_by: { en: "Filter by", hi: "फ़िल्टर करें" },
    all: { en: "All", hi: "सभी" },
  },
};

export function tx(key, lang) {
  const parts = key.split(".");
  let node = T;
  for (const p of parts) node = node?.[p];
  if (!node) return key;
  return node[lang] || node.en || key;
}
